import { configureStore } from '@reduxjs/toolkit'; 
import AuthReducer from '../reducers/AuthReducer'; 
import DateFormateReducer from '../reducers/DateFormateReducer'; 
import ThemeReducer from '../reducers/ThemeReducer'; 
import IsMasterContentLoaderReducer from '../reducers/IsMasterContentLoaderReducer';
import OptionsReducer from '../reducers/OptionsReducer';
  
const store = configureStore(
    {
    reducer: { 
        auth: AuthReducer,
        dateFormate: DateFormateReducer,
        theme: ThemeReducer, 
        options: OptionsReducer,
        isMasterContentLoader: IsMasterContentLoaderReducer
        // More slices to manage different states
    },
    //middleware: [thunk],
})

 
export default store;
